import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-error-page',
  templateUrl: './errorpage.component.html',
  imports: [RouterLink, ButtonModule],
  standalone: true,
})
export class ErrorPageComponent {}
